<template>
  <section :class="style['details-page']">
    <div v-theme :class="style['details-content-header']" @click="$emit('back')">
      <span class="material-symbols-outlined filled" :class="style['material-icon']"
        >arrow_back_ios</span
      >
      <span
        v-if="
          contentComponentInfo.icon_type === componentIconType.MATERIAL_ICON &&
          contentComponentInfo.icon
        "
        class="material-symbols-outlined filled"
        :class="style['material-icon']"
        v-html="contentComponentInfo.icon"
      ></span>
      <img
        v-else-if="
          contentComponentInfo.icon_type === componentIconType.CUSTOM &&
          contentComponentInfo.icon_image
        "
        :src="contentComponentInfo.icon_image.thumbnail"
        :class="style['custom-icon']"
        alt="icon"
      />
      <span :class="style['header-text']">{{ contentComponentInfo.title }}</span>
    </div>
    <div :class="style['details-page-main']">
      <iframe style="width: 100%; height: 100%" :src="iframeSrc" frameborder="0"></iframe>
    </div>
  </section>
</template>

<script>
import style from './scss/_pages.scss'
import { useSettingsStore } from 'Store/settings'
import { componentIconType } from 'src/constants/chatMenu'

export default {
  props: {
    contentComponentInfo: {
      type: Object,
      default: null
    }
  },
  setup() {
    return {
      style,
      componentIconType,
      settingsStore: useSettingsStore()
    }
  },
  data() {
    const guideDomain = new URL(this.settingsStore.getSettings.guide_url || process.env.GUIDE_URL)
    return {
      iframeSrc: `${guideDomain.origin}/guide-viewers/${this.contentComponentInfo.uuid}?locale=${this.$i18n.locale}`
    }
  }
}
</script>
